module.exports = __webpack_public_path__ + "img/puff_red.03d48759.png";